import React, { useContext, useState }  from 'react';
import {
    AiOutlineCalendar,
    AiOutlineClockCircle,
    AiOutlineUser,
} from "react-icons/ai";
import { HiHeart, HiOutlineHeart } from "react-icons/hi";
import { GoLocation } from "react-icons/go";
import { CiWarning } from "react-icons/ci";
import toast from "react-hot-toast";
import { TbCurrencyTaka } from "react-icons/tb";
import BookingModal from '../../../Component/BookingModal/BookingModal';
import { useDbUser } from '../../../hooks/useUser';
import { AuthContext } from '../../../Context/UseContext';

const Advertisement = ({ advertise }) => {
    const { user } = useContext(AuthContext);
    const [dbUser] = useDbUser(user?.email);
    const [booking, setBooking] = useState(null);
    const [wishlistLoading, setWishlistLoading] = useState(false);

    const handleWishlist = (id) => {
        setWishlistLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}/wishlist/add/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setWishlistLoading(false);
                    toast.success(data.message);
                } else {
                    setWishlistLoading(false);
                    toast.error(data.message);
                }
            });
    };

    const handleReport = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}/products/reported/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.modifiedCount > 0) {
                    toast.success("Make report successful.");
                    // setIsLoading(false)
                } else {
                    toast.error("Please login first");
                }
            });
    };

    const handleBooking = (id) => {
        if(!user || !dbUser){
            toast.error("Please login first");
            return;
        }
        setBooking(id);
    }
    
    return (
        <>
            <div className="dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-5 py-20">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-3xl font-bold text-blue-700 dark:text-white/90 text-center">
                        Sponsored Ads
                    </h2>

                    <div className="py-10 flex flex-wrap gap-6 justify-center items-center">
                        {
                            advertise?.map((product) => (
                                <div key={product._id} className="max-w-[330px] w-full bg-white rounded-md shadow dark:bg-gray-900 drop-shadow-md dark:text-gray-100 p-3 flex flex-col justify-between text-center hover:-translate-y-1 duration-300 relative">
                                    <div className="absolute top-3 right-3 shadow-lg">
                                        <button
                                            onClick={() => handleReport(product?._id)}
                                            className="btn btn-warning btn-xs font-normal"
                                        >
                                            <CiWarning className="mr-1 stroke-1" />
                                            Report
                                        </button>
                                    </div>
                                    <div>
                                        <figure>
                                            <img
                                                src={product?.img}
                                                alt={product?.title}
                                                className="object-cover object-center w-full rounded-lg h-48 dark:bg-gray-500"
                                            />
                                        </figure>

                                        <div className="pt-2">
                                            <div>
                                                <div className="flex flex-col items-center">
                                                    <h2 className="text-lg font-semibold text-ellipsis">
                                                        {product?.title}
                                                    </h2>
                                                    <div className="flex items-center gap-2">
                                                        <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
                                                            Condition:
                                                        </p>
                                                        <span
                                                            className={`badge ${product?.condition === "excellent"
                                                                ? "badge-success"
                                                                : product?.condition === "Good"
                                                                    ? "badge-info"
                                                                    : "badge-warning"}`}
                                >
                                    {product?.condition}
                                </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex flex-col justify-center text-center py-2 gap-1">
                                                <div className="flex justify-evenly items-center">
                                                    <div className="flex items-center text-blue-700 text-md">
                                                        <span className="text-gray-800 dark:text-gray-300">
                                                            Resale:
                                                        </span>
                                                        <TbCurrencyTaka className="w-5 h-5" />
                                                        {product?.resellerPrice}
                                                    </div>

                                                    <div className="flex items-center text-blue-700 text-md">
                                                        <span className="text-gray-800 dark:text-gray-300">
                                                            Original:
                                                        </span>
                                                        <TbCurrencyTaka className="w-5 h-5" />
                                                        {product?.originalPrice}
                                                    </div>
                                                </div>

                                                <div className="flex flex-wrap justify-evenly items-center text-gray-500 text-sm dark:text-gray-400">
                                                    <div className="flex items-center gap-1 justify-center w-fit">
                                                        <GoLocation className="text-blue-700 stroke-1" />
                                                        <span>{product?.location}</span>
                                                    </div>
                                                    <div className="flex items-center justify-center gap-1 w-fit">
                                                        <AiOutlineClockCircle className="text-blue-700 stroke-1" />
                                                        <span>{product?.post_time}</span>
                                                    </div>
                                                </div>

                                                <div className="flex justify-evenly items-center gap-1 dark:text-gray-300">
                                                    <div className="flex items-center justify-center gap-1 w-fit">
                                                        <AiOutlineUser className="text-blue-700" />
                                                        <span>{product?.seller_name}</span>
                                                        {/* {productInfo?.seller_isVerified && (
                                    <span title="Verified Seller">
                                        <FcApproval />
                                    </span>
                                )} */}
                                                    </div>

                                                    <div className="flex items-center gap-1 justify-center w-fit">
                                                        <AiOutlineCalendar className="text-blue-700" />
                                                        <span>
                                                            {product?.yearOfUsed}{" "}
                                                            {product?.yearOfUsed > 1 ? "years used" : "year used"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs">
                                            {product?.description.length > 100
                        ? product?.description.slice(0, 100) + "..."
                        : product?.description}
                                        </p>
                                    </div>

                                    <div className="flex flex-wrap items-center gap-2 px-3 py-2">
                                        <label
                                            htmlFor="booking-modal"
                                            onClick={() => handleBooking(product)}
                                            title="View Details"
                                            className="flex-1 btn btn-primary btn-sm"
                                        // disabled={bookLoading && productId === productInfo?._id}
                                        >
                                            {/* <div className="flex items-center gap-2 ">
                        {bookLoading && productId === productInfo?._id ? (
                            <Spinner size="sm" light={true} />
                        ) : (
                            <HiOutlineBookmark className="h-5 w-5" />
                        )}
                        <span>Book Now</span>
                    </div> */}
                                            <span>Book Now</span>
                                        </label>
                                        <button
                                            onClick={() => handleWishlist(product._id)}
                                            className="btn btn-sm btn-success">
                                            {wishlistLoading ? (
                                                <HiHeart className="w-8 h-8 text-red-700 cursor-pointer" />
                                            ) : (
                                                <HiOutlineHeart className="w-8 h-8 cursor-pointer text-white" />
                                            )}
                                        </button>
                                    </div>
                                </div>
))
                        }
                    </div>
                </div>
            </div>

            {booking && <BookingModal booking={booking} setBooking={setBooking} />}
        </>
    );
};

export default Advertisement;